export enum CacheKey {
  TOKEN = 'token',
  REQUESTED_URL = 'requested-url',
}
